import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import * as $ from "jquery";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../services/validation.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { Globals } from '../globals';
import { ContactService } from '../services/contact.service';
import { Response } from '../interface/response';
import { from } from 'rxjs';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  activeHome: String = 'false';
  reloadOnce: Boolean = false;
  theGlobal: any;

  projects: Array<{
    id: number,
    title: string,
    description: string,
    url: string,
    link: string
  }>;

  chunkProjects: Array<{ id: number, title: string, description: string, url: string }>;
  contactForm: FormGroup; // form
  contactFormMobile: FormGroup; // form
  contactServ: any;
  constructor(private activatedRoute: ActivatedRoute,
    globals: Globals,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private contactService: ContactService,
    private gtmService: GoogleTagManagerService,
    private router: Router) {

    this.theGlobal = globals;
    this.contactServ = contactService;

    this.contactForm = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
    });

    this.contactFormMobile = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
    });

  }

  ngOnInit(): void {

    // push GTM data layer for every visited page
    this.router.events.forEach(item => {
      // console.log('hey > ', item);
      // console.log(item instanceof NavigationEnd);
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        console.log('tag > ', gtmTag);
        this.gtmService.pushTag(gtmTag);
      }
    });
    this.projects = [
      {
        id: 1, 
        title: 'LM Maskotas',
        description: 'Es una empresa que quiere mostrar los productos que vende para mascotas de todo tipo y en el que se puede apreciar su misión visión e información de contacto con mapa y formulario.',
        url: 'assets/img/home/sec3/projects/lmmockup_2.png',
        link: 'http://www.lmmaskotas.com/'
      },
      {
        id: 2,
        title: 'Equipos Veterinarios',
        description: 'Es una empresa centrada en maquinas de uso en veterinarias de todo tipo y en el que se puede apreciar su misión visión e información de contacto con mapa y formulario.',
        url: 'assets/img/home/sec3/projects/aygequiposveterinarios_3.png',
        link: 'http://www.agequiposveterinarios.com/'
      },
      {
        id: 3, 
        title: 'Ilustración',
        description: 'Para redes sociales, fue una mejora en manejo en composición de elementos, paleta de color y tipografía.',
        url: 'assets/img/home/sec3/projects/illustration_post.png',
        link: 'https://www.behance.net/romarioestrada'
      },
    ];
    if (this.projects.length <= 3) {
      this.chunkProjects = this.chunkArray(this.projects, 2);
    }
    // if (this.projects.length >= 4) {
    //   this.chunkProjects = this.chunkArray(this.projects, 3);
    // }


    // console.log('chunkProjects > ', this.chunkProjects);

    this.activeHome = 'true';
    $('#personalizedParallax').html(null);
    this.loadScripts();
    this.theGlobal.menuLoadder();
    this.theGlobal.checkIfIsInTheHome(this.route.snapshot.paramMap.get("contact"));
    // this used because if the last section paused the audio, 
    // when the section init, pause the audio too, or play, it depends.
    this.theGlobal.switchSound();
  }

  chunkArray(array, size) {
    const chunked_arr = [];
    let copied = [...array]; // ES6 destructuring
    const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
    for (let i = 0; i < numOfChild; i++) {
      chunked_arr.push(copied.splice(0, size));
    }
    return chunked_arr;
  }

  loadScripts() {
    const scriptsToLoad = [
      "../assets/js/home/parallax.js",
      "../assets/js/home/animations.js"
    ];

    for (let i = 0; i < scriptsToLoad.length; i++) {
      const body = <HTMLDivElement>document.body;
      let divScripts = document.getElementById('personalizedParallax');
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = scriptsToLoad[i];
      script.async = false;
      script.defer = true;
      divScripts.appendChild(script);
    }
  }

  sendContact() {
    if (this.contactForm.dirty && this.contactForm.valid) {

      this.contactServ.saveContact(this.contactForm.value.email).subscribe((res) => {
        // console.log('res > ',res);
        if (res.status) {
          console.log(res.message);
          console.log('se envió correctamente la información! si lees esto e spor que eres desarrollador...unete!')
        } else {
          console.log('hubo un error al enviar la información!')
        }
        // if(!res.status){
        //   console.log('res.error.name > ',res.error.name);
        //   if(res.error.name == 'SequelizeUniqueConstraintError'){
        //     console.log('ya había enviado ese correo mk');
        //   }
        // }
      });

    } else {

    }

  }

  sendContactMobile() {
    if (this.contactFormMobile.dirty && this.contactFormMobile.valid) {

      this.contactServ.saveContact(this.contactFormMobile.value.email).subscribe((res) => {
        // console.log('res > ',res);
        if (res.status) {
          console.log(res.message);
          console.log('se envió correctamente la información! si lees esto e spor que eres desarrollador...unete!')
        } else {
          console.log('hubo un error al enviar la información!')
        }
        // if(!res.status){
        //   console.log('res.error.name > ',res.error.name);
        //   if(res.error.name == 'SequelizeUniqueConstraintError'){
        //     console.log('ya había enviado ese correo mk');
        //   }
        // }
      });

    } else {

    }

  }

}
